module.exports = __webpack_public_path__ + "img/img-9-desk.e4b75e0d.jpg";